export const trimLastSlashFromUrl = (baseUrl: string) => {
    if (baseUrl == null || baseUrl === '') {
        return null;
    } else if (baseUrl[baseUrl.length - 1] === '/') {
        return baseUrl.substring(0, baseUrl.length - 1);
    } else {
        return baseUrl;
    }
};
